import { InputDecimal, SaveButton } from '@/components/_common';
import {
  useCreateQuotaFcpSettings,
  useEditeQuotaFcpSettings,
  useQuotaFcpSettings,
} from '@/core/domain/invoice/settings/Settings.hooks';
import {
  QuotaFcpSettingsForm,
  QuotaFcpSettingsRequest,
  StateType,
  StateValidUf,
} from '@/core/domain/invoice/settings/Settings.types';
import { Col, Form, Row, Table } from 'antd';
import { useEffect } from 'react';

interface Props {
  invoiceSettingsId: number;
}

const InvoiceQuotaFcpSettings = ({ invoiceSettingsId }: Props) => {
  const [form] = Form.useForm<QuotaFcpSettingsForm>();
  const { mutateAsync: createMutateAsync } = useCreateQuotaFcpSettings();
  const { mutateAsync: editeMutateAsync } = useEditeQuotaFcpSettings();
  const {
    data: quotaData,
    dataUpdatedAt,
    isLoading,
  } = useQuotaFcpSettings(invoiceSettingsId);

  useEffect(() => {
    if (dataUpdatedAt) {
      const values = { ...quotaData?.pages[0] };
      delete values.invoiceSettingsId;

      form.setFieldsValue({ ...values });
    }
  }, [dataUpdatedAt]);

  const handleSubmit = async () => {
    try {
      const formValues = form.getFieldsValue();

      if (invoiceSettingsId && formValues) {
        const obj: QuotaFcpSettingsRequest = {
          ...formValues,
        };
        if (quotaData?.pages[0].invoiceSettingsId) {
          await editeMutateAsync({ obj, id: invoiceSettingsId });
        } else {
          await createMutateAsync({ obj, id: invoiceSettingsId });
        }
      }
    } catch {}
  };

  const initialData = [
    { uf: 'ac', quota: 0 },
    { uf: 'al', quota: 0 },
    { uf: 'am', quota: 0 },
    { uf: 'ap', quota: 0 },
    { uf: 'ba', quota: 0 },
    { uf: 'ce', quota: 0 },
    { uf: 'df', quota: 0 },
    { uf: 'es', quota: 0 },
    { uf: 'go', quota: 0 },
    { uf: 'ma', quota: 0 },
    { uf: 'mg', quota: 0 },
    { uf: 'ms', quota: 0 },
    { uf: 'mt', quota: 0 },
    { uf: 'pa', quota: 0 },
    { uf: 'pb', quota: 0 },
    { uf: 'pe', quota: 0 },
    { uf: 'pi', quota: 0 },
    { uf: 'pr', quota: 0 },
    { uf: 'rj', quota: 0 },
    { uf: 'rn', quota: 0 },
    { uf: 'ro', quota: 0 },
    { uf: 'rr', quota: 0 },
    { uf: 'rs', quota: 0 },
    { uf: 'sc', quota: 0 },
    { uf: 'se', quota: 0 },
    { uf: 'sp', quota: 0 },
    { uf: 'to', quota: 0 },
  ];

  const columns = [
    {
      dataIndex: 'uf',
      title: 'Estado',
      ellipsis: true,
      width: 200,
      render: (value: StateValidUf) => {
        return StateType[value];
      },
    },
    {
      dataIndex: 'quota',
      title: 'Alíquota',
      ellipsis: true,
      width: 200,
      render: (_: unknown, row: { uf: string; quota: number }) => (
        <Col>
          <Form.Item name={row.uf} noStyle initialValue={row.quota}>
            <InputDecimal max={100} fractions={4} />
          </Form.Item>
        </Col>
      ),
    },
  ];

  return (
    <Form form={form}>
      <Row gutter={[16, 16]}>
        <SaveButton onClick={handleSubmit}>Salvar Alíquota</SaveButton>

        <Table
          columns={columns}
          dataSource={initialData}
          rowKey={(row) => row.uf}
          pagination={false}
          loading={isLoading}
        />
      </Row>
    </Form>
  );
};

export default InvoiceQuotaFcpSettings;
